import { CorporateBondId, moodysRatingComparator, spRatingComparator } from "@goodfill/domain-properties";
import {
  stringComparator,
  decimalComparator,
  datetimeComparator,
  Comparator,
  nullableComparator,
} from "@goodfill/sort";
import { PresentedTradeTicket } from "./PresentedTradeTicket";

export type PresentedTradeTicketComparator = (a: PresentedTradeTicket, b: PresentedTradeTicket) => number;

export type PresentedAccountBondHoldingForSort = PresentedTradeTicket;

export function getTradeHistoryComparator(
  sortColumn: keyof PresentedAccountBondHoldingForSort,
): PresentedTradeTicketComparator {
  const comparators: Comparator<PresentedAccountBondHoldingForSort> = {
    direction: stringComparator,
    amount: decimalComparator,
    tradeDate: datetimeComparator,
    settlementDate: datetimeComparator,
    orderTicketId: (a, b) => stringComparator(a.toString(), b.toString()),
    finalCommissionAmount: decimalComparator,
    paymentRank: stringComparator,
    isin: stringComparator,
    couponPayment: decimalComparator,
    maturityDate: datetimeComparator,
    ticker: stringComparator,
    issuerName: stringComparator,
    accruedInterest: decimalComparator,
    settlementValue: decimalComparator,
    tradeValue: decimalComparator,
    tradeTicketId: (a, b) => stringComparator(a.toString(), b.toString()),
    bondTimezone: stringComparator,
    loadedTradePrice: decimalComparator,
    bondRatingMoodys: nullableComparator(moodysRatingComparator),
    bondRatingSp: nullableComparator(spRatingComparator),
    bondId: (a, b) => stringComparator(a.toString(), b.toString()),
    issuerId: (a, b) => stringComparator(a.toString(), b.toString()),
  };

  const comparator: (
    a: PresentedTradeTicket[keyof PresentedAccountBondHoldingForSort],
    b: PresentedTradeTicket[keyof PresentedAccountBondHoldingForSort],
  ) => number =
    // rome-ignore lint/suspicious/noExplicitAny:
    comparators[sortColumn] as any;

  if (comparator === undefined) {
    throw new Error(`Comparator for ${sortColumn} not found!`);
  }

  return (a: PresentedTradeTicket, b: PresentedTradeTicket) => comparator(a[sortColumn], b[sortColumn]);
}
